// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const IacIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 40 40">
    <path
      fill="url(#iac_svga)"
      d="M12.31 5h-1.03a5.77 5.77 0 0 0-5.99 5.96v5.22c0 .95-.7 1.8-1.62 1.97a.4.4 0 0 0-.33.4v1.16c0 .19.14.36.33.4a2.1 2.1 0 0 1 1.62 2v5.13a5.77 5.77 0 0 0 5.99 5.95h1.03a.4.4 0 0 0 .4-.4V31.5a.4.4 0 0 0-.4-.4h-1.03a3.77 3.77 0 0 1-3.84-3.87v-5.13a4 4 0 0 0-1.39-2.93 4 4 0 0 0 1.39-3v-5.22c0-2.2 1.65-3.87 3.84-3.87h1.03a.4.4 0 0 0 .4-.4V5.4a.4.4 0 0 0-.4-.4"
    />
    <path
      fill="url(#iac_svgb)"
      d="M36.34 18.15a2 2 0 0 1-1.63-1.98v-4.6q0-.66-.03-1.18A5.8 5.8 0 0 0 28.73 5H27.7a.4.4 0 0 0-.4.4v1.28c0 .23.18.4.4.4h.72c1.92 0 4.16 1.02 4.16 3.87v5.22c0 1.17.54 2.3 1.39 3a4 4 0 0 0-1.4 2.94v5.13a3.7 3.7 0 0 1-3.83 3.86H27.7a.4.4 0 0 0-.4.4v1.28c0 .23.18.4.4.4h1.04c3.47 0 5.98-2.5 5.98-5.94V22.1c0-.96.72-1.84 1.63-2.01a.4.4 0 0 0 .33-.4v-1.15a.4.4 0 0 0-.33-.4"
    />
    <path
      fill="url(#iac_svgc)"
      fillRule="evenodd"
      d="M27.74 10.79c.51 0 .93.42.93.93v2.77c0 .51-.42.93-.93.93H12.92a.93.93 0 0 1-.93-.93v-2.77c0-.51.42-.93.93-.93zm-12.82 2.9q.1-.01.12-.11v-.95a.12.12 0 0 0-.12-.12h-.95a.12.12 0 0 0-.12.12v.95q0 .1.12.12zm1.9.01q.12 0 .13-.12v-.95a.12.12 0 0 0-.13-.12h-.47a.12.12 0 0 0-.12.12v.95q.01.11.12.12z"
      clipRule="evenodd"
    />
    <path
      fill="url(#iac_svgd)"
      fillRule="evenodd"
      d="M27.74 16.81c.51 0 .93.42.93.93v2.78c0 .51-.42.93-.93.93H12.92a.93.93 0 0 1-.93-.93v-2.78c0-.5.42-.93.93-.93zm-12.82 2.91q.1 0 .12-.12v-.95a.12.12 0 0 0-.12-.12h-.95a.12.12 0 0 0-.12.12v.95q0 .11.12.12zm1.9.01q.12 0 .13-.12v-.95a.12.12 0 0 0-.13-.12h-.47a.12.12 0 0 0-.12.12v.95q.01.11.12.12z"
      clipRule="evenodd"
    />
    <path
      fill="url(#iac_svge)"
      fillRule="evenodd"
      d="M27.74 22.84c.51 0 .93.41.93.93v2.77c0 .51-.42.93-.93.93H12.92a.93.93 0 0 1-.93-.93v-2.77c0-.52.42-.93.93-.93zm-10.92 2.91q.12 0 .13-.12v-.95a.12.12 0 0 0-.13-.12h-.47a.12.12 0 0 0-.12.12v.95q.01.11.12.12zm-1.9 0q.1-.01.12-.13v-.94a.12.12 0 0 0-.12-.13h-.95a.12.12 0 0 0-.12.13v.94q0 .12.12.13z"
      clipRule="evenodd"
    />
    <defs>
      <linearGradient
        id="iac_svga"
        x1={3.34}
        x2={19.97}
        y1={5}
        y2={10.27}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9147FF" />
        <stop offset={1} stopColor="#4C35E8" />
      </linearGradient>
      <linearGradient
        id="iac_svgb"
        x1={27.29}
        x2={43.92}
        y1={5}
        y2={10.26}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9147FF" />
        <stop offset={1} stopColor="#4C35E8" />
      </linearGradient>
      <linearGradient
        id="iac_svgc"
        x1={11.99}
        x2={14.55}
        y1={10.79}
        y2={19.55}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9147FF" />
        <stop offset={1} stopColor="#4C35E8" />
      </linearGradient>
      <linearGradient
        id="iac_svgd"
        x1={11.99}
        x2={14.55}
        y1={16.81}
        y2={25.57}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9147FF" />
        <stop offset={1} stopColor="#4C35E8" />
      </linearGradient>
      <linearGradient
        id="iac_svge"
        x1={11.99}
        x2={14.55}
        y1={22.84}
        y2={31.6}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9147FF" />
        <stop offset={1} stopColor="#4C35E8" />
      </linearGradient>
    </defs>
  </svg>,
  "Iac",
);
export default IacIcon;
